import api from './api';
// 获取专家列表
export function getExpertList(params) {
  return api.post('/expert/list.html', params, false, false).then(res => res);
}
// 新增专家信息
export function addExpert(params) {
  return api.post('/expert/save.html', params).then(res => res);
}
// 获取专家详细信息
export function getExpertById(params) {
  return api.post('/expert/info', params, false, false).then(res => res);
}
// 修改专家信息
export function updateExpertById(params) {
  return api.post('/expert/update.html', params).then(res => res);
}
// 删除专家信息
export function deleteExpert(params) {
  return api.post('/expert/del.html', params).then(res => res);
}
// 获取用户列表
export function getUserList(params) {
  return api.post('user/userslist.html', params, false, false).then(res => res);
}
// 更改用户启用状态
export function changeStatus(params) {
  return api.post('/user/status.html', params, false, false).then(res => res);
}
// 添加用户
export function adduser(params) {
  return api.post('/user/adduser.html', params, false, false).then(res => res);
}
// 更新用户
export function updateUser(params) {
  return api.post('/user/upuser.html', params, false, false).then(res => res);
}
// 删除用户
export function deletuser(params) {
  return api.post('/user/deletuser.html', params, false, false).then(res => res);
}



// WEBPACK FOOTER //
// ./src/api/userCenter.js